import React, { useState } from "react";
import "./style.css";
import CustomRadioButton from "../../../../components/CustomRadioButton";
import {
  useGetProductPoliciesQuery,
  usePostProductPolicyInfoMutation,
} from "../../../../rtk-query/slices/createProduct/ProductPolicy/productPolicySlice";
import { Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { ShimmerContentBlock } from "react-shimmer-effects";

function CPPoliciesMain({ productDetail, productId, setCurrentTab }) {
  const navigate = useNavigate();
  const [postProductPolicyInfo, { isLoading }] =
    usePostProductPolicyInfoMutation();
  const { data: productPoliciesData, isLoading: isProductPoliciesDataLoading } =
    useGetProductPoliciesQuery();
  const [selectedPolicy, setSelectedPolicy] = useState(
    productDetail?.data?.product_polices?.id || null
  );
  const [error, setError] = useState("");

  const handleSubmit = async () => {
    try {
      if (selectedPolicy !== null) {
        const formData = new FormData();
        formData.append("product_id", productId);
        formData.append("product_policy_id", selectedPolicy);
        const response = await postProductPolicyInfo(formData);

        if (response?.data?.status) {
          toast.success(response?.data?.message, {
            position: "top-center",
            autoClose: 3000,
          });
          setCurrentTab(5);
        }
        if (response?.error) {
          const errors = response?.error?.data?.errors;
          if (response?.error?.status === 401) {
            localStorage.removeItem("DODLoginToken");
            toast.error(response?.error?.data?.message, {
              position: "top-center",
              autoClose: 3000,
            });
            navigate("/login");
          } else if (errors) {
            for (const field in errors) {
              if (errors.hasOwnProperty(field)) {
                // const combinedErrors = errors[field].join(" ");
                // if (field === "supplier_type") {
                //   setFieldError("option", combinedErrors);
                // }
              }
            }
            toast.error(response?.error?.data?.message, {
              position: "top-center",
              autoClose: 3000,
            });
          } else {
            toast.error(response?.error?.data?.message, {
              position: "top-center",
              autoClose: 3000,
            });
          }
        }
      } else {
        setError("Please select a policy.");
      }
    } catch (error) {}
  };

  return (
    <div className="ob-pi-form-container cp-ps-main-container">
      <h3 className=".ob-supplier-content-heading m-0">
        Your cancellation policy
      </h3>
      {productPoliciesData && productPoliciesData?.data?.length > 0 && (
        <>
          <div className="d-flex flex-column cp-policy-checkbox-container">
            <div className="cp-policy-checkbox">
              <div className="cp-policy-checkbox-head">
                <CustomRadioButton
                  label={productPoliciesData?.data[0]?.title}
                  isSelected={
                    selectedPolicy === productPoliciesData?.data[0]?.id
                  }
                  onClick={() => {
                    setError("");
                    setSelectedPolicy(productPoliciesData?.data[0]?.id);
                  }}
                />
              </div>
              {productPoliciesData?.data[0]?.detailsDescription && (
                <p
                  dangerouslySetInnerHTML={{
                    __html: productPoliciesData?.data[0]?.detailsDescription,
                  }}
                  className=""
                ></p>
              )}
            </div>
            <div className="cp-policy-checkbox">
              <div className="cp-policy-checkbox-head">
                <CustomRadioButton
                  label={productPoliciesData?.data[1]?.title}
                  isSelected={
                    selectedPolicy === productPoliciesData?.data[1]?.id
                  }
                  onClick={() => {
                    setError("");
                    setSelectedPolicy(productPoliciesData?.data[1]?.id);
                  }}
                />
              </div>
              {productPoliciesData?.data[0]?.detailsDescription && (
                <p
                  dangerouslySetInnerHTML={{
                    __html: productPoliciesData?.data[0]?.detailsDescription,
                  }}
                  className=""
                ></p>
              )}
            </div>
            {error && <p className="text-danger">{error}</p>}
          </div>
          <div className="cp-policy-redemption-container">
            <h3 className="cp-form-heading m-0">
              {productPoliciesData?.data[2]?.title}
            </h3>
            <ul className="list-unstyled">
              <li className="d-flex align-items-start">
                <span className="me-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="8"
                    height="8"
                    viewBox="0 0 8 8"
                    fill="none"
                  >
                    <circle cx="4" cy="4" r="4" fill="#EB662B" />
                  </svg>
                </span>
                {productPoliciesData?.data[2]?.detailsDescription && (
                  <p
                    dangerouslySetInnerHTML={{
                      __html: productPoliciesData?.data[2]?.detailsDescription,
                    }}
                    className="m-0"
                  ></p>
                )}
              </li>
              {/* {Array(6)
                .fill()
                .map((_, index) => (
                  <li key={index} className="d-flex align-items-start">
                    <span className="me-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="8"
                        height="8"
                        viewBox="0 0 8 8"
                        fill="none"
                      >
                        <circle cx="4" cy="4" r="4" fill="#EB662B" />
                      </svg>
                    </span>
                    <p className="m-0">
                      It is a long established fact that a reader will be distracted
                      by the readable content of a page
                    </p>
                  </li>
                ))} */}
            </ul>
          </div>
          <div className="w-100 d-flex align-items-center justify-content-between create-product-footer-btn-container">
            <button className="back-btn" onClick={() => setCurrentTab(3)}>
              Back
            </button>
            <button
              type="submit"
              className="submit-btn"
              onClick={handleSubmit}
              disabled={isLoading}
              // onClick={() => {
              //   setData((prevData) => [...prevData, 1]);
              //   handleClose();
              // }}
            >
              Save & Continue
              {isLoading && <Spinner size="sm" className="ms-1" />}
            </button>
          </div>
        </>
      )}

      {isProductPoliciesDataLoading && (
        <ShimmerContentBlock
          title
          text
          cta
          thumbnailWidth={370}
          thumbnailHeight={370}
        />
      )}
    </div>
  );
}

export default CPPoliciesMain;
